"use strict";

/**
 * @module Services.SessionLock
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SessionLockAcquisition = void 0;
/**
 * Data type for the ACQUIRE_SESSION_LOCK and RELEASE_SESSION_LOCK requests.
 */
var SessionLockAcquisition = /** @class */function () {
  /**
   * Create a new SessionLockAcquisition instance
   *
   * @param lockName  the lock name
   * @param sequence  the session lock sequence number
   * @param scope  the lock scope
   */
  function SessionLockAcquisition(lockName, sequence, scope) {
    this.lockName = lockName;
    this.sequence = sequence;
    this.scope = scope;
  }
  return SessionLockAcquisition;
}();
exports.SessionLockAcquisition = SessionLockAcquisition;